module.exports = __webpack_public_path__ + "img/cii-widget-chartview.ecfda51e.png";